// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__t7DLZ","filesListContainer":"PosDisputesFiles_filesListContainer__1X5Hj","filesButton":"PosDisputesFiles_filesButton__2caBk"};